import React from 'react';
import { useTheme } from '../../theme-context';

const ThemeToggle: React.FC = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex h-12 w-full rounded-lg bg-[#F5F5F5] p-1 shadow-inner dark:bg-black">
      <button
        className={`flex h-full min-w-[50%] items-center gap-2 rounded-lg px-4 transition-colors ${
          theme === 'light' ? 'bg-white text-black' : 'text-gray-500'
        }`}
        onClick={() => setTheme('light')}
      >
        <img
          src={`/assets/navigation-icons/sidebar/${
            theme === 'light' ? 'light-mode.svg' : 'light-mode-disabled.svg'
          }`}
          alt="Light Mode"
          className="w-4 h-4"
        />
        <span>Light</span>
      </button>

      <button
        className={`flex h-full min-w-[50%] items-center gap-2 rounded-lg px-4 transition-colors ${
          theme === 'dark' ? 'text-[#C8CEDA] bg-[#3E3E3E]' : 'text-gray-500'
        }`}
        onClick={() => setTheme('dark')}
      >
        <img
          src={`/assets/navigation-icons/sidebar/${
            theme === 'dark' ? 'dark-mode.svg' : 'light-mode-disabled.svg'
          }`}
          alt="Dark Mode"
          className="w-4 h-4"
        />
        <span>Dark</span>
      </button>
    </div>
  );
};

export default ThemeToggle;
